import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { KeycloakService } from 'keycloak-angular';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private authSrv: AuthService,
        private keycloak: KeycloakService
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Escludi l'endpoint di configurazione di Keycloak dall'interceptor,
        // altrimenti si crea un loop durante l'inizializzazione.
        if (req.url.includes('/api/v1/keycloak')) {
            return next.handle(req);
        }
        this.keycloak.getToken().then(token => {
            //console.log('Keycloak token:', token);
        });
        return from(this.keycloak.getToken()).pipe(
            switchMap(token => {
                //console.log('Keycloak token:', token);
                const tokenDevice = this.authSrv.getetDeviceToken();
                const tokenCounter = this.authSrv.getCounterToken();
                if (token || tokenDevice || tokenCounter) {
                    const clonedRequest = req.clone({
                        setHeaders: {
                            Authorization: token ? `Bearer ${token}` : '',
                            'x-device-token': tokenDevice ?? '',
                            'x-counter-token': tokenCounter ?? ''
                        }
                    });
                    return next.handle(clonedRequest);
                }
                return next.handle(req);
            })
        );
    }
}